module.exports = __webpack_public_path__ + "img/research-mall-update-single.a895eaee.png";